import {
  Component,
  Output,
  EventEmitter,
  ViewChild,
  Input,
} from '@angular/core';
import { ModalController, App, NavController } from 'ionic-angular';
import { UserProvider } from '../../../providers/user/user';
import { ToolsProvider } from '../../../providers/tools/tools';
import * as debug from 'debug';
import * as _ from 'lodash';
import { AppVersion } from '@ionic-native/app-version';
import { EnvVariables } from '../../../environments/environment';
import { ConfigProvider } from '../../../providers/config/config';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'lc-typing-users',
  templateUrl: 'typing-users.html',
})
export class LCTypingUsersComponent {
  log = debug('app:LCTypingUsersComponent');

  @Input() user: {} = {};
  @Input() multipleTypers: boolean = false;
  @Input() allTypingUsers: [] = [];
  @Input() typingUserCount = 0;

  constructor(public loggedInUser: UserProvider) {}

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/components/_live-chat/typing-users/typing-users.ts